import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, AlertTriangleIcon, MessageCircleIcon } from 'lucide-react';
import { trackRegistroCompletado } from '../utils/metaPixel';
const WHATSAPP_CHANNEL_URL = 'https://group.wha.link/boA9Ae';
function WhatsAppIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-51">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-52" />
    </svg>;
}
export function RegistrationForm() {
  return <section id="registro" className="w-full bg-navy px-4 py-16 md:py-20" data-id="element-53">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7
    }} className="max-w-md mx-auto bg-navy-card border border-navy-border rounded-2xl p-8 md:p-10 text-center" data-id="element-54">
        <div className="flex items-center justify-center gap-2 mb-2" data-id="element-55">
          <LockIcon className="w-5 h-5 text-red" data-id="element-56" />
          <h2 className="font-oswald text-2xl md:text-3xl font-bold text-white uppercase" data-id="element-57">
            Reserva Tu Lugar GRATIS
          </h2>
        </div>
        <p className="text-gray font-inter text-sm mb-8" data-id="element-58">
          Los cupos son limitados
        </p>

        <p className="text-white font-inter text-base md:text-lg leading-relaxed mb-8" data-id="element-59">
          Haz clic en el botón y únete a nuestro canal de WhatsApp para recibir
          el enlace de la clase
        </p>

        <motion.a href={WHATSAPP_CHANNEL_URL} target="_blank" rel="noopener noreferrer" onClick={trackRegistroCompletado} whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.97
      }} className="inline-flex items-center justify-center gap-3 w-full bg-[#25D366] hover:bg-[#20bd5a] text-white font-oswald font-bold text-lg md:text-xl uppercase py-5 rounded-lg btn-pulse-green transition-colors" data-id="element-60">
          <WhatsAppIcon className="w-6 h-6" data-id="element-61" />
          UNIRME AL CANAL DE WHATSAPP
        </motion.a>

        <div className="flex items-center justify-center gap-2 mt-5" data-id="element-62">
          <LockIcon className="w-4 h-4 text-gray/50" data-id="element-63" />
          <p className="text-gray/60 text-xs font-inter" data-id="element-64">
            Gratis. Sin spam. Sin compromisos.
          </p>
        </div>

        <div className="flex items-center justify-center gap-2 mt-3" data-id="element-65">
          <AlertTriangleIcon className="w-4 h-4 text-red" data-id="element-66" />
          <p className="text-red text-xs font-oswald uppercase tracking-wide" data-id="element-67">
            Los cupos son limitados. Únete ahora!
          </p>
        </div>
      </motion.div>
    </section>;
}